export const getDefaultJobImage = (jobTitle: string): string => {
  const title = jobTitle.toLowerCase();

  // Chef-related jobs - using a professional chef cooking image
  if (title.includes('chef') || title.includes('cocinero') || title.includes('cocina')) {
    return 'https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=1920&q=80';
  }

  // Waiter/Server-related jobs
  if (title.includes('waiter') || title.includes('camarero') || title.includes('mesero') ||
      title.includes('server') || title.includes('camarera')) {
    return 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=1920&q=80';
  }

  // Bartender
  if (title.includes('bartender') || title.includes('barman') || title.includes('camarero de barra')) {
    return 'https://images.unsplash.com/photo-1514933651103-005eec06c04b?w=1920&q=80';
  }

  // Kitchen staff
  if (title.includes('kitchen') || title.includes('ayudante de cocina') || title.includes('kitchen helper')) {
    return 'https://images.unsplash.com/photo-1556911220-bff31c812dba?w=1920&q=80';
  }

  // Hospitality/Hotel
  if (title.includes('hotel') || title.includes('hospitality') || title.includes('hostelería') ||
      title.includes('recepción') || title.includes('reception')) {
    return 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1920&q=80';
  }

  // Restaurant management
  if (title.includes('manager') || title.includes('gerente') || title.includes('director')) {
    return 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=1920&q=80';
  }

  // Cleaning/Housekeeping
  if (title.includes('cleaning') || title.includes('limpieza') || title.includes('housekeeping')) {
    return 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=1920&q=80';
  }

  // Default office/professional image
  return 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=1920&q=80';
};
